import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { triContainer } from '../../di/container';

export function useClassTriConfidenceStudents(editionId: string) {
  const { institutionName } = useInstitutionStore();

  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: [
      'tri',
      'class-tri-confidence-students',
      institutionName,
      editionId,
    ],
    queryFn: () =>
      triContainer.repository.getClassTriConfidenceStudents(editionId),
    enabled: isAuthenticated && !!editionId,
    retry: false,
  });
}
